"use client";

import { translations } from "@/messages";
import { replaceParams } from "@/utils/replaceParams";
import { useLocale } from "use-intl";
type ProgressBarProps = {
  percentage: number;
};
const ProgressBar: React.FC<ProgressBarProps> = ({
  percentage
}) => {
  const locale = useLocale() as keyof typeof translations;
  const percentageText = replaceParams(translations[locale]["institution"]["percentageText"], {
    percentage: percentage.toString()
  }) as string;
  return <div className="relative h-5 w-full select-none bg-foreground/30 mobile:h-5" data-sentry-component="ProgressBar" data-sentry-source-file="ProgressBar.tsx">
      <div style={{
      width: `${percentage}%`
    }} className="absolute h-5 bg-green-500 transition-all duration-500 ease-in-out dark:bg-green-600 mobile:h-5"></div>
      <span className="absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 text-center text-xs font-semibold uppercase text-destructive-foreground">
        {percentageText}
      </span>
    </div>;
};
export default ProgressBar;